<script setup lang="ts">
import SkeletonLoader from '@apparatix/library/SkeletonLoader.vue';

type Props = {
  headerLoading?: boolean,
  contentLoading?: boolean,
};

const props = defineProps<Props>();
</script>
<template>
  <div class="h-full w-full flex flex-col gap-4 p-4 lg:px-6">
    <div class="grow-0">
      <SkeletonLoader
        :loading="props.headerLoading"
        :rows="[
          {columns: 2, shape: 'rounded', height: '2rem'},
          {columns: 12, shape: 'rounded', height: '2rem'}
        ]"
        fade-after-load
      >
        <div class="flex flex-col">
          <div class="py-2">
            <slot name="headerTopRow" />
          </div>
          <div class="py-2">
            <slot name="headerBottomRow" />
          </div>
        </div>
      </SkeletonLoader>
    </div>
    <div class="grow overflow-y-auto tour-step-1">
      <SkeletonLoader
        :loading="props.contentLoading"
        :rows="12"
        :columns="2"
        justify-around
        fade-after-load
      >
        <section>
          <slot />
        </section>
      </SkeletonLoader>
    </div>
  </div>
</template>
